import { SurveyQuestion } from '@/api';
import RadioQuestion from './RadioQuestion';
import CheckboxQuestion from './CheckboxQuestion';
import TextareaQuestion from './TextareaQuestion';

interface QuestionCardProps {
  question: SurveyQuestion;
  index: number;
  value: string | string[] | undefined;
  onRadioChange: (questionId: number, value: string) => void;
  onCheckboxChange: (questionId: number, value: string, checked: boolean) => void;
  onTextChange: (questionId: number, value: string) => void;
}

const QuestionCard = ({
  question,
  index,
  value,
  onRadioChange,
  onCheckboxChange,
  onTextChange,
}: QuestionCardProps) => {
  return (
    <div className="mx-auto flex w-full max-w-[780px] flex-col gap-3 rounded-xl border border-black bg-white px-[14px] py-5">
      <p className="font-Pretendard text-base font-bold leading-[90%] tracking-normal text-[#111111]">
        {question.questionText}
      </p>

      {question.questionType === 'RADIO' && (
        <RadioQuestion
          questionId={question.questionId}
          options={question.options}
          value={value as string | undefined}
          onChange={onRadioChange}
        />
      )}

      {question.questionType === 'CHECKBOX' && (
        <CheckboxQuestion
          questionId={question.questionId}
          options={question.options}
          value={value as string[] | undefined}
          onChange={onCheckboxChange}
        />
      )}

      {question.questionType === 'TEXTAREA' && (
        <TextareaQuestion
          questionId={question.questionId}
          value={value as string | undefined}
          onChange={onTextChange}
        />
      )}
    </div>
  );
};

export default QuestionCard;
